import React from 'react';
import { motion } from 'framer-motion';
import { AlertOctagon, X } from 'lucide-react';
import { useTheme } from '../../contexts/ThemeContext';
import { useManuals } from '../../contexts/ManualsContext';

export const DeleteConfirmationModal = () => {
    const { darkMode } = useTheme();
    const {
        showDeleteManualModal, setShowDeleteManualModal,
        manualToDelete,
        deleteManual,
        manuals,
        showDeleteCategoryModal, setShowDeleteCategoryModal,
        categoryToDelete,
        deleteCategory,
        categories
    } = useManuals();

    if (!showDeleteManualModal && !showDeleteCategoryModal) return null;

    const isManual = showDeleteManualModal;
    const item = isManual ? manualToDelete : categoryToDelete;
    const title = isManual
        ? manuals[item?.categoryId]?.find(m => m.id === item?.id)?.title
        : categories.find(c => c.id === item?.id)?.name;

    const handleDelete = () => {
        if (isManual) {
            deleteManual(item.categoryId, item.id);
            setShowDeleteManualModal(false);
        } else {
            deleteCategory(item.id);
            setShowDeleteCategoryModal(false);
        }
    };

    const handleClose = () => {
        if (isManual) setShowDeleteManualModal(false);
        else setShowDeleteCategoryModal(false);
    };

    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50"
            onClick={handleClose}
        >
            <div
                className={`rounded-xl shadow-2xl w-full max-w-md p-6 ${
                    darkMode ? 'bg-gray-800' : 'bg-white'
                }`}
                onClick={e => e.stopPropagation()}
            >
                <div className="flex justify-center mb-4">
                    <div className={`${darkMode ? 'bg-red-900' : 'bg-red-100'} p-3 rounded-full`}>
                        <AlertOctagon className={`w-8 h-8 ${darkMode ? 'text-red-400' : 'text-red-600'}`} />
                    </div>
                </div>
                <h2 className={`text-xl font-bold text-center mb-2 ${darkMode ? 'text-white' : 'text-gray-800'}`}>Подтверждение удаления</h2>
                <p className={`text-center mb-6 ${darkMode ? 'text-gray-300' : 'text-gray-600'}`}>
                    {isManual
                        ? `Вы уверены, что хотите удалить руководство "${title}"? Это действие нельзя отменить.`
                        : `Вы уверены, что хотите удалить раздел "${title}"? Все руководства в этом разделе также будут удалены. Это действие нельзя отменить.`
                    }
                </p>
                <div className="flex justify-center space-x-4">
                    <button
                        onClick={handleClose}
                        className={`px-6 py-2 rounded-lg transition-colors ${
                            darkMode
                                ? 'border border-gray-600 text-gray-300 hover:bg-gray-700'
                                : 'border border-gray-300 text-gray-700 hover:bg-gray-50'
                        }`}
                    >
                        Отмена
                    </button>
                    <button
                        onClick={handleDelete}
                        className={`px-6 py-2 rounded-lg transition-colors ${
                            darkMode ? 'bg-red-600 hover:bg-red-700 text-white' : 'bg-red-600 hover:bg-red-700 text-white'
                        }`}
                    >
                        Удалить
                    </button>
                </div>
            </div>
        </motion.div>
    );
};